import { FieldNames } from 'Constants/FieldNames'
import {
	BenefInfoType,
	BgRequestType,
	BgStatus,
	GuaranteeMediumType,
	LegalAuthorityType,
	ReputationType,
} from 'Pages/ibro'
import { FormNames } from 'Constants/FormNames'

export const AMOUNT_COEFF = 1.5
export const COMMISSION_COEFF = 2

export enum BgRequestNav {
	GUARANTEE_BLANK, // Банковская гарантия
	GUARANTEE_PROJECT, // Проект гарантии
	DOCUMENTS, // документы
	ABOUT_BG, // общая информация (Параметры гарантии)
	COST, // стоимость гарантии
	CLIENT_INFO, // сведения о заявителе
	TAX_REPORT, // налоги и отчетность
}

export const defaultValue = {
	[FieldNames.AUTHPASSPORT]: 'Паспорт РФ',
	[FieldNames.FLAGLICENSE]: false,
	[FieldNames.BENEF]: BenefInfoType.UNASSIGNED,
	[FieldNames.PERSONREZIDFLAG]: false,
	[FieldNames.FACTS]: 'NoFacts',
	[FieldNames.GUARANTEEMEDIUMTYPE]: GuaranteeMediumType.ELECTRONIC,
	[FieldNames.FLAGSOVET]: false,
	[FieldNames.FATCAFLAG]: false,
	[FieldNames.ISAGENTBENEF]: false,
	[FieldNames.ORGREZIDFLAG]: true,
	[FieldNames.TYPELEGALAUTHORITY]: LegalAuthorityType.NO,
	[FieldNames.REPUTATION]: ReputationType.NONE,
	[FieldNames.ISBIGDEAL]: false,
	[FieldNames.ISSTATENO]: false,
	[FieldNames.ACTINGUNDER]: 'Устава',
	[FieldNames.PROTOTEXT]: '',
	[FieldNames.SIGNEDCONTRACTFLAG]: false,
}

export const statusUpdateCommission = [
	BgStatus.CL_CHECKED,
	BgStatus.CREATED,
	BgStatus.FILLING,
	BgStatus.REWORK,
]

export const disableDocumentRequests = [BgRequestType.CHECK_STATUS, BgRequestType.UPDATE_REQUEST]

export const PROTECTED_DOCUMENTS = [
	FieldNames.ANKETAFSC,
	FieldNames.GENDIRSCAN,
	FieldNames.IPSCAN,
	FieldNames.PROTOCOLGENDIRSCAN,
	FieldNames.USTAV,
	FieldNames.EGRUL,
	FieldNames.FINANCIALSTATEMENT,
	FieldNames.BIGDEALPROTOCOL,
	FieldNames.SUPPORTDOC,
	FieldNames.OTHERDOCS,
]

export const AuthPassportFieldsToValidate = [
	FieldNames.AUTHPASSPORTSER,
	FieldNames.AUTHPASSPORTNUM,
	FieldNames.AUTHPASSPORTDATEGIVE,
	FieldNames.AUTHPASSPORTKOD,
]

export const AuthPassportDirectorFieldsToValidate = [
	FieldNames.AUTHPASSPORTSER_DIRECTOR,
	FieldNames.AUTHPASSPORTNUM_DIRECTOR,
	FieldNames.AUTHPASSPORTDATEGIVE_DIRECTOR,
	FieldNames.AUTHPASSPORTKOD_DIRECTOR,
]

export const BgRequestNeoTranslate = {
	[BgRequestNav.GUARANTEE_BLANK]: 'Банковская гарантия',
	[BgRequestNav.DOCUMENTS]: 'Документы',
	[BgRequestNav.ABOUT_BG]: 'Параметры гарантии',
	[BgRequestNav.COST]: 'Стоимость гарантии',
	[BgRequestNav.CLIENT_INFO]: 'Сведения о заявителе',
	[BgRequestNav.TAX_REPORT]: 'Налоги и отчетность',
	[BgRequestNav.GUARANTEE_PROJECT]: 'Проект гарантии',
}

export const isStateNoTranslate = {
	true: 'Входит в одну из категорий',
	false: 'Не имеет отношения к данным категориям',
}

export enum OrderSource {
	NEO,
	API,
}

export enum NOTIFICATION_SETTINGS {
	FAVORITE = 'favorite',
	EMAIL = 'email',
	OFF = 'off',
}

export const purchUrlRegex = /^(https?:\/\/)?(www\.)?zakupki.gov.ru\/epz\/contract\/contractCard/

export const purchaseCodeLength = 50

export const amountLength = 12

export const contractsubjectMaxLendgth = 2000

export const bgFormNames = {
	[BgRequestNav.GUARANTEE_BLANK]: FormNames.BROKER.REQUEST.GUARANTEE_BLANK,
	[BgRequestNav.GUARANTEE_PROJECT]: FormNames.BROKER.REQUEST.GUARANTEE_PROJECT,
	[BgRequestNav.DOCUMENTS]: FormNames.BROKER.REQUEST.DOCUMENTS,
	[BgRequestNav.ABOUT_BG]: FormNames.BROKER.REQUEST.ABOUT,
	[BgRequestNav.COST]: FormNames.BROKER.REQUEST.COST,
	[BgRequestNav.CLIENT_INFO]: FormNames.BROKER.REQUEST.CLIENT_INFO,
	[BgRequestNav.TAX_REPORT]: FormNames.BROKER.REQUEST.TAX_REPORT,
}

export const optionsEventNotification = [
	{
		value: 'off',
		label: 'Не получать уведомления',
		key: NOTIFICATION_SETTINGS.OFF,
	},
	{
		value: 'email',
		label: 'Получать уведомления по всем заявкам',
		key: NOTIFICATION_SETTINGS.EMAIL,
	},
	{
		value: 'favorite',
		label: 'Получать уведомления по избранным заявкам',
		key: NOTIFICATION_SETTINGS.FAVORITE,
	},
]

export const fieldsToLock = [
	FieldNames.AUTHPERSONCITIZENSHIP,
	FieldNames.AUTHPERSONDATE,
	FieldNames.AUTHPERSONPLACE,
	FieldNames.AUTHADDRESS,
	FieldNames.AUTHPOSITION,
	FieldNames.ACTINGUNDER,
	FieldNames.AUTHPASSPORT,
	FieldNames.AUTHPASSPORTSER,
	FieldNames.AUTHPASSPORTNUM,
	FieldNames.AUTHPASSPORTDATEGIVE,
	FieldNames.AUTHPASSPORTKOD,
	FieldNames.AUTHPASSPORTWHOGIVE,
	FieldNames.AUTHINN,
	FieldNames.AGREEMENT_DIRECTOR_SIGN,
]

export const editableStatus = [
	BgStatus.CL_CHECKED,
	BgStatus.NOVA,
	BgStatus.FILLING,
	BgStatus.REWORK,
]
